
import React from 'react';
import { ArrowRight } from 'lucide-react';

function CallToAction() {
  return (
    <section className="section section-padding">
      <div className="container">
        <div className="gradient-blue has-text-centered box px-5 py-6">
          <h2 className="title is-2 mb-4">
          Ready to Boost Your Walmart Sales?
          </h2>
          <p className="subtitle is-5 mb-5" style={{maxWidth: "800px", margin: "0 auto", opacity: 0.9}}>
          Join over 5,000 sellers who use Marter's solutions daily.
          </p>
          <div className="buttons is-centered">
            <a className="button is-white is-medium" href="https://www.getmarter.com/pioneers">
              Get Started Today
            </a>
            <a className="button is-outlined is-medium" style={{color: "white", borderColor: "white"}} onClick={() => alert("Email us at info@getmarter.com")}>
              <span>Talk to an Advisor</span>
              <span className="icon">
                <ArrowRight size={20} />
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CallToAction;
